import {
  Alert,
  Box,
  Button,
  ButtonGroup,
  Divider,
  Heading,
  Modal,
  Paragraph,
  TextButton,
} from '@zillow/constellation-10';

import { css } from '@/styled-system/css';

import { useAutoSpotlight } from './AutoSpotlightContext';
import { SPOTLIGHT_COPY as COPY } from './spotlightCopy';

export function SmartAssignDisableModal() {
  const ctx = useAutoSpotlight();

  if (!ctx) {
    return null;
  }

  const {
    autoCount,
    cancelDisableSmartAssign,
    confirmDisableSmartAssign,
    isDisableSmartAssignRequested,
    isDisablingSmartAssign,
    pinnedCount,
  } = ctx;

  // Controlled, so the guard below is what blocks the close button, Escape and the backdrop while in flight.
  return (
    <Modal.Root
      open={isDisableSmartAssignRequested}
      onOpenChange={(next) => !next && !isDisablingSmartAssign && cancelDisableSmartAssign()}
      size={{ base: 'fullScreen', md: 'sm' }}
    >
      <Modal.Portal>
        <Modal.Backdrop>
          {/* oxlint-disable-next-line constellation/no-raw-spacing-values */}
          <Modal.Content data-panda-theme="zillow" css={{ md: { maxWidth: '480px', width: '480px' } }}>
            <Modal.Header>
              <Heading level={2} textStyle="heading-sm">
                {COPY.disableModal.title}
              </Heading>
            </Modal.Header>
            <Divider />
            <Modal.Body>
              <Box css={{ display: 'flex', flexDirection: 'column', gap: '400', alignItems: 'flex-start' }}>
                {autoCount > 0 ? (
                  <Alert tone="warning" css={{ alignSelf: 'stretch' }}>
                    <span className={css({ fontWeight: 'bold' })}>
                      {autoCount} Smart Assign listing{autoCount === 1 ? '' : 's'} will lose Listing Spotlight.
                    </span>
                    {pinnedCount > 0 &&
                      ` ${pinnedCount} pinned listing${pinnedCount === 1 ? '' : 's'} will keep Listing Spotlight.`}
                  </Alert>
                ) : (
                  pinnedCount > 0 && (
                    <Paragraph>
                      {pinnedCount} pinned listing{pinnedCount === 1 ? '' : 's'} will keep Listing Spotlight.
                    </Paragraph>
                  )
                )}
                <Paragraph>{COPY.disableModal.description}</Paragraph>
              </Box>
            </Modal.Body>
            <Divider />
            <Modal.Footer>
              <ButtonGroup aria-label="Actions">
                <TextButton tone="brand" onClick={cancelDisableSmartAssign} disabled={isDisablingSmartAssign}>
                  {COPY.disableModal.cancel}
                </TextButton>
                <Button
                  tone="critical"
                  emphasis="filled"
                  size="md"
                  onClick={confirmDisableSmartAssign}
                  disabled={isDisablingSmartAssign}
                >
                  {COPY.disableModal.confirm}
                </Button>
              </ButtonGroup>
            </Modal.Footer>
            <Modal.CloseButton />
          </Modal.Content>
        </Modal.Backdrop>
      </Modal.Portal>
    </Modal.Root>
  );
}

export default SmartAssignDisableModal;
